// Generated by CoffeeScript 1.10.0
(function () {
  var regexEscape, reverse;
  regexEscape = require('escape-string-regexp');

  reverse = function (s) {
    return s.split('').reverse().join('');
  };

  module.exports = function (s, chars, escapeChar) {
    var regex;

    if (chars == null) {
      chars = '\'';
    }

    if (escapeChar == null) {
      escapeChar = '\\';
    }

    if (typeof s !== 'string') {
      return s;
    }

    regex = new RegExp("([" + regexEscape(chars) + "])(?!" + regexEscape(escapeChar) + ")", 'g');
    return reverse(reverse(s).replace(regex, "$1" + escapeChar));
  };
}).call(this);